export const GET_POSITION_SUCCESS = "GET_POSITION_SUCCESS";
export const DELETE_POSITION_SUCCESS = "DELETE_POSITION_SUCCESS";
